import { Box, Button, Container, Paper, Stack, Typography, useTheme } from "@mui/material";
import { ChevronRight } from "@mui/icons-material";
import { GridLayout } from "./grid-layout.js";
import { HorizontalScrollLayout } from "./horizontal-scroll-layout.js";
import { ProductContext } from "../provider.js";
import { useMediaQuery } from "../../utilities/index.js";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import React from "react";
export const RelatedProducts = ({ isDesktop, showPrice = true, }) => {
    const { t } = useTranslation(["c-product", "c-common"]);
    const theme = useTheme();
    const { edition, relatedProducts } = React.useContext(ProductContext);
    const isAtLeastSm = useMediaQuery(theme.breakpoints.up("sm"));
    const inDesktopMode = isDesktop ?? isAtLeastSm;
    const backgroundColor = theme.palette.grey[50];
    return (React.createElement(Paper, { component: "section", id: "product-related-products", sx: {
            backgroundColor,
            borderRadius: 0,
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            pb: { xs: 6, sm: 8, md: 10, xl: 14 },
            pt: { xs: 5, md: 7, xl: 14 },
        } },
        React.createElement(Container, { maxWidth: "xl" },
            React.createElement(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", sx: { pt: 1, pb: 6 } },
                React.createElement(Box, null,
                    React.createElement(Typography, { variant: "h2", sx: { pt: 0, pb: 0.5 } }, edition === "online"
                        ? t("recommended-products-online-headline", "Weitere Online-Krimispiele")
                        : t("recommended-products-print-headline", "Weitere Krimispiele")),
                    React.createElement(Typography, { variant: "body1" }, t("recommended-products-copy-1", "Diese Krimidinnner könnten dir auch gefallen."))),
                inDesktopMode && (React.createElement(Button, { endIcon: React.createElement(ChevronRight, null), href: edition === "online"
                        ? "/" + t("c-common:slug-online", "online-krimidinner")
                        : "/" + t("c-common:slug-print", "krimidinner"), LinkComponent: Link, sx: { "&.MuiButton-root": { px: 1.5, mx: -1.5 } }, variant: "text" }, t("show-all-cases", "Alle Fälle anzeigen"))))),
        inDesktopMode ? (React.createElement(GridLayout, { products: relatedProducts, showPrice: showPrice })) : (React.createElement(HorizontalScrollLayout, { products: relatedProducts, showPrice: showPrice }))));
};
//# sourceMappingURL=related-products.js.map